module.exports = __webpack_public_path__ + "img/seed logo.8cee8a30.png";